import { RegisterScreen } from "@/features/auth";

export default RegisterScreen;
